import { createUseStyles } from "react-jss";

export default createUseStyles((theme: any) => ({
    choiceText: {
        composes: "choice__text",
        fontWeight: ({ fontWeight }) => fontWeight ?? "bolder",
        flex: 1,
    },
    spacer: {
        width: 20,
        flex: theme.DisplayChoiceIcon === "right" && 1,
    },
}));
